import { render, staticRenderFns } from "./TipoServ.vue?vue&type=template&id=e3b3cf9c&"
import script from "./TipoServ.vue?vue&type=script&lang=js&"
export * from "./TipoServ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports